import React, { useEffect, useRef } from "react"
import { string } from "prop-types"
import { Page, PageBody, PageContent } from "core/layout/page"

function getMeta(name) {
  const tag = document.querySelector(`meta[name='${name}']`)
  return tag && tag.content
}

const AutomaticClickPrevention = ({ url }) => {
  const formRef = useRef(null)
  const csrf_token = getMeta("csrf-token")
  const csrf_param = getMeta("csrf-param")

  useEffect(() => {
    window.setTimeout(() => {
      formRef.current.submit()
    }, 100)
  }, [])

  return (
    <Page className="bg-warm-white-100">
      <PageBody className="container">
        <PageContent className="flex flex-col flex-auto h-full">
          <section className="flex flex-col mt-24 mb-8 mx-auto rounded-lg bg-white w-2/3 max-w-3xl min-w-full md:min-w-0">
            <form action={url} method="POST" ref={formRef}>
              <input type="hidden" name={csrf_param} value={csrf_token} />
              <p className="text-center text-gray-900 p-4">Redirecting...</p>
            </form>
          </section>
        </PageContent>
      </PageBody>
    </Page>
  )
}

AutomaticClickPrevention.propTypes = {
  url: string.isRequired
}

export default AutomaticClickPrevention
